// src/pages/Coaching.jsx
import React from "react";
import CoachingImage from "../assets/Pillars/Pillar2.png";
import Footer from "../components/homepage/Footer";

export default function Coaching() {
  return (
    <div className="w-full">

      {/* Hero Section */}
      <section className="flex justify-center items-center py-16 px-4 md:px-8">
        <div className="border-2 border-gray-200 rounded-2xl backdrop-blur-sm p-5 md:p-10 max-w-[90%] w-full flex flex-col md:flex-row items-center gap-10 bg-black/30">
          
          {/* Text Left */}
          <div className="md:w-2/3 text-center md:text-left">
            <h1 className="text-white text-5xl md:text-6xl font-bold mb-4">Personal Coaching</h1>
            <p className="text-neonTurquoise text-xl md:text-2xl mb-4">
              One-on-one guidance to reach your fitness, performance, and lifestyle goals.
            </p>
            <p className="text-grayText text-base md:text-lg">
              Tailored coaching plans for endurance, strength, sports performance, and nutrition. Receive expert support every step of the way.
            </p>
          </div>

          {/* Image Right */}
          <div className="md:w-1/3 flex justify-center md:justify-end">
            <img src={CoachingImage} alt="Coaching Hero" className="rounded-lg shadow-lg max-w-full h-auto"/>
          </div>

        </div>
      </section>

      {/* Coaching Programs Section */}
      <section className="py-16 px-4 md:px-8 flex flex-col items-center gap-12">
        <div className="border-2 border-gray-200 rounded-2xl backdrop-blur-sm p-5 md:p-12 max-w-[90%] w-full bg-black/30">
          <h2 className="text-white text-3xl md:text-4xl font-bold mb-6">Coaching Programs</h2>
          <ul className="text-grayText text-base md:text-lg list-disc list-inside space-y-4">
            <li>Endurance Coaching: Build stamina with structured weekly plans and progress tracking.</li>
            <li>Strength & Aesthetic Coaching: Personalized strength programs and nutrition guidance.</li>
            <li>Sport-Specific Coaching: Optimize performance with drills, SAQ, and recovery strategies.</li>
            <li>Nutrition & Lifestyle Guidance: Meal plans, supplement advice, and recovery protocols.</li>
            <li>Virtual or In-Person Sessions: Flexible scheduling to suit your lifestyle.</li>
          </ul>
          <div className="text-center mt-8">
            <a href="/contact" className="bg-neonTurquoise text-black font-bold px-6 py-3 rounded-lg hover:bg-cyan-400 transition duration-300">
              Apply Now
            </a>
          </div>
        </div>
      </section>
      {/* Footer */}
      <Footer />
    </div>
  );
}
